import { hasCookiesEnabled } from 'util/browser'
import storage from 'util/storage'
import { getUncachedVersion } from 'util/version'
import { getTabId } from 'util/tabId'

// eslint-disable-next-line func-names
export function buildUserForBugsnag(user) {
  // Grab the user from LocalStorage, if we have it.
  const currentUser = user || storage.get('currentUser')
  if (!currentUser) return undefined
  const bugsnagUser = {
    ...currentUser,
    avatar_url: undefined,
  }
  delete bugsnagUser.email // yay GDPR
  delete bugsnagUser.first_name
  delete bugsnagUser.last_name
  delete bugsnagUser.name
  delete bugsnagUser.username
  return bugsnagUser
}

// eslint-disable-next-line func-names
export function buildAccountForBugsnag(account = {}) {
  const { subdomain = '' } = account
  return {
    subdomain,
  }
}

export const bootstrap = env => {
  // ensure the variable is set, we will overwrite it
  // when we get the client
  global.bugsnagClient = null
  const version = getUncachedVersion()
  if (window.location.host.match('.docker')) return
  if (window.bugsnag) {
    const bugsnagClient = window.bugsnag({
      apiKey: '33d5fbb590d86e3dac76839b7fef7a70',
      appVersion: version !== '' ? version : 'development-build',
      releaseStage: env,
      notifyReleaseStages: ['production', 'staging'],
      consoleBreadcrumbsEnabled: false,
      metaData: {
        localStorageEnabled: storage.checkAvailability(),
        cookiesEnabled: hasCookiesEnabled(),
        tabId: getTabId(),
        account: buildAccountForBugsnag(),
      },
      beforeSend: report => {
        // don't auto-report unhandled promise rejections
        // we do that in src/util/global-exceptions.js
        // and we end up having double reports
        try {
          const reason = report.toJSON().severityReason.type
          if (reason === 'unhandledPromiseRejection') {
            report.ignore()
          }
          // remove targetText as it tends to include customer data
          report.breadcrumbs.forEach(breadcrumb => {
            if (breadcrumb.name === 'UI click') {
              report.removeMetaData('targetText')
              try {
                breadcrumb.metadata.targetText = null
              } catch (e) {
                // pass
              }
            }
          })
        } catch (e) {
          // pass
        }
        return true
      },
      user: buildUserForBugsnag(),
    })
    global.bugsnagClient = bugsnagClient
  } else {
    if (env !== 'test') console.error('Bugsnag not initialized') // eslint-disable-line no-console
    if (env === 'test') {
      global.bugsnagClient = {
        notify: () => {},
      }
    }
  }
}
